module.exports = __webpack_public_path__ + "img/sesb-logo-report.156609eb.png";